import { render } from "./TopbarComp.vue?vue&type=template&id=1531c11c"
import script from "./TopbarComp.vue?vue&type=script&lang=js"
export * from "./TopbarComp.vue?vue&type=script&lang=js"

import "./TopbarComp.vue?vue&type=style&index=0&id=1531c11c&lang=css"

import exportComponent from "C:\\Users\\stage\\NetttFormApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__